module.exports = __webpack_public_path__ + "img/sym-noti-01.1918ef48.svg";